import { useResourceKit } from '@resource-kit/core/react';
import { cn } from '../../cn';
import type { HTMLAttributes } from 'react';

interface LoadingProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'default' | 'lg';
}

const Loading = ({ className, size = 'default', ...props }: LoadingProps) => {
  const { t } = useResourceKit();
  const sizeClasses: Record<'sm' | 'default' | 'lg', string> = {
    sm: 'w-4 h-4',
    default: 'w-6 h-6',
    lg: 'w-8 h-8',
  };

  return (
    <div
      role="status"
      aria-label={t('rk.ui.loading')}
      className={cn('flex items-center justify-center', className)}
      {...props}
    >
      <div
        className={cn(
          'animate-spin rounded-full border-2 border-muted border-t-primary',
          sizeClasses[size],
        )}
      />
    </div>
  );
};

const LoadingPage = ({ message }: { message?: string }) => {
  const { t } = useResourceKit();
  const resolvedMessage = message ?? t('rk.ui.loading');
  return (
    <div className="flex flex-col items-center justify-center h-64 space-y-4">
      <Loading size="lg" />
      <p className="text-muted-foreground">{resolvedMessage}</p>
    </div>
  );
};

export { Loading, LoadingPage };
